<template>
  <div class="custom-audio" onselectstart="return false" :class="disabled?'disabled':''">
    <i v-if="isPaused" @click="playAudio" class="el-icon-video-pause"></i>
    <i v-else @click="playAudio" class="el-icon-caret-right"></i>
    <span class="time">{{time}}</span>
    <div class="audio-progress" ref="audioProgress" @mousedown="controlAudioProgress($event)">
      <span class="bar" :style="progressStyle"></span>
    </div>
    <span class="time">{{duration}}</span>
    <svg-icon icon-class="download" @click="downloadAudio" class="audio-download"></svg-icon>

    <el-dropdown v-if="!isCustom" placement="top">
      <span class="ml-10 speed">{{multipleIndex==null||multipleIndex==2?'倍速':multipleArray[multipleIndex]+'X'}}</span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item v-for="(item,index) in multipleArray" :key="index" :class="multipleIndex==index?'active':''" @click.native="changeMultiple(index)">{{item}}x</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <!-- 兼容客户旅程：bug hover里面套hover 鼠标移到倍速的下拉列表就隐藏父级气泡 -->
    <div v-else class="speed-wrap" @mouseenter="isShow=true" @mouseleave="isShow=false">
      <ul class="el-dropdown-menu el-popper" :style="{display:isShow? '':'none'}">
        <li class="el-dropdown-menu__item" v-for="(item,index) in multipleArray" :key="index" :class="multipleIndex==index?'active':''" @click="changeMultiple(index)">{{item}}x</li>
        <div class="popper__arrow" style="left: 26.5px;"></div>
      </ul>
      <span class="ml-10 speed">{{multipleIndex==null||multipleIndex==2?'倍速':multipleArray[multipleIndex]+'X'}}</span>
    </div>

    <audio ref="recordAudio" class="recordAudio" type="audio/mpeg" @canplay="canPlay" @timeupdate="timeUpdate" @ended="onEnded" :src="audioUrl">
    </audio>
  </div>
</template>

<script>
import { getRecordingAddress } from '@/views/call/api'
// import Bus from '@/utils/bus'
export default {
  name: 'audioPlay',
  props: {
    uniqueId: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    },
    isCustom: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      // http://m704.music.126.net/20220124105004/5a1c0ffa54340227b33b43ecd2e3ea79/jdyyaac/obj/w5rDlsOJwrLDjj7CmsOj/11637511723/248b/0f26/3a19/c4dcbf1a5ad983f4c90523c77563e6c6.m4a?authSecret=0000017e89e6b39d17e00aaba546ddca
      audioUrl: '',
      time: '00:00', // 当前播放时间
      duration: '00:00', // 总时长
      progressStyle: { width: '' },
      isPaused: false,
      disabled: false,
      loading: false,
      multipleArray: ['2', '1.5', '1', '0.5'], // ['0.5', '1', '1.5', '2'],
      multipleIndex: 2,

      isShow: false
    }
  },
  created () {
    // Bus.$on('resetAudio', (val) => {
    //   const recordAudio = this.$refs.recordAudio
    //   this.isPaused = false
    //   // this.audioUrl = ''
    //   this.multipleIndex = 2
    //   recordAudio.pause()
    // })
  },
  mounted () {
    if (this.url) {
      this.audioUrl = this.url
    } else {
      this.disabled = true
      getRecordingAddress({ requiredId: this.uniqueId }).then(res => {
        if (res.code === '0') {
          this.audioUrl = res.data
          this.disabled = false
        }
      })
    }
  },
  methods: {
    getPause () {
      const recordAudio = this.$refs.recordAudio
      this.isPaused = false
      recordAudio.currentTime = 0
      recordAudio.pause()
      this.multipleIndex = 2
    },
    // 播放、暂停控制
    playAudio () {
      if (this.disabled) return
      const recordAudio = this.$refs.recordAudio
      if (recordAudio) {
        if (recordAudio.paused) {
          this.isPaused = true
          this.$emit('reset2Audio', this.audioUrl)
          setTimeout(() => {
            recordAudio.play()
          }, 10)
        } else {
          this.isPaused = false
          setTimeout(() => {
            recordAudio.pause()
          }, 10)
        }
      }
    },

    // 进度条更新
    timeUpdate () {
      const recordAudio = this.$refs.recordAudio
      if (recordAudio) {
        const timeStr = parseInt(recordAudio.currentTime)
        this.time = this.transTime(timeStr)
        const scales = recordAudio.currentTime / recordAudio.duration
        this.progressStyle.width = scales * 100 + '%'
        // 获取audio音频文件总时长 并设置到界面并解决出现 NAN 的问题
        this.duration = isNaN(recordAudio.duration) ? '00:00' : this.transTime(recordAudio.duration)
        this.disabled = this.duration === '00:00'
        console.log(this.duration)
      }
    },

    // 播放结束 重置数据
    onEnded () {
      this.isPaused = false
      this.time = '00:00'
      this.progressStyle.width = 0
    },

    // 用户可以开始播放audio （录音有问题不走这个回调）
    canPlay () {
      const recordAudio = this.$refs.recordAudio
      if (recordAudio) {
        this.duration = this.transTime(this.$refs.recordAudio.duration)
      }
      this.disabled = this.duration === '00:00'
    },

    // 鼠标点击移动播放进度
    controlAudioProgress (event) {
      const audio = this.$refs.recordAudio
      const audioProgress = this.$refs.audioProgress
      if (!audio.paused || audio.currentTime !== 0) {
        const pgsWidth = parseFloat(window.getComputedStyle(audioProgress, null).width.replace('px', ''))
        const rate = event.offsetX / pgsWidth
        audio.currentTime = audio.duration * rate
        this.timeUpdate()
      }
    },
    // 倍速
    changeMultiple (index) {
      this.multipleIndex = index
      const audioPlayer = this.$refs.recordAudio
      audioPlayer.playbackRate = this.multipleArray[index]
      if (this.isCustom) {
        this.isShow = false
      }
    },

    // 下载音频
    downloadAudio () {
      if (this.disabled) return
      if (!this.audioUrl) return
      const arr = this.audioUrl.split('/')
      this.downloadMp3(this.audioUrl, arr[arr.length - 1])
    },
    // 第三方录音地址持久化到本地，地址转化存在时间差，可能有未转化成功的情况，下载需分情况
    downloadMp3 (filePath, fileName) {
      if (filePath.indexOf('71360.com') > -1) {
        const link = document.createElement('a')
        fetch(`${filePath}?t=${+new Date().getTime()}`).then(res => res.blob()).then(blob => {
          const href = URL.createObjectURL(blob)
          if (window.navigator.msSaveBlob) {
            // 垃圾浏览器兼容
            try {
              window.navigator.msSaveBlob(blob, fileName)
            } catch (error) {
              console.error(error)
            }
          } else {
            // 标准浏览器
            link.href = href
            link.download = fileName
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
            window.URL.revokeObjectURL(href)
          }
        }).catch(err => {
          console.error(err)
        })
      } else {
        // .wav chrome不支持直接下载
        var aLink = document.createElement('a')
        aLink.style.display = 'none'
        aLink.download = fileName
        aLink.href = filePath
        document.body.appendChild(aLink)
        aLink.click()
        document.body.removeChild(aLink)
      }
    },

    // 时间转换
    transTime (value) {
      let time = ''
      const h = parseInt(value / 3600)
      value %= 3600
      const m = parseInt(value / 60)
      const s = parseInt(value % 60)
      if (h > 0) {
        time = this.formatTime(h + ':' + m + ':' + s)
      } else {
        time = this.formatTime(m + ':' + s)
      }
      return time
    },

    // 时间格式化
    formatTime (value) {
      let time = ''
      const s = value.split(':')
      let i = 0
      for (; i < s.length - 1; i++) {
        time += s[i].length === 1 ? ('0' + s[i]) : s[i]
        time += ':'
      }
      time += s[i].length === 1 ? ('0' + s[i]) : s[i]
      return time
    }
  },
  beforeDestroy () {
    // 正在播放则关闭
    const recordAudio = this.$refs.recordAudio
    if (this.isPaused) {
      setTimeout(() => {
        recordAudio.pause()
        recordAudio.playbackRate = 1
      }, 10)
    }
    this.$bus.$off('resetAudio')
  }
}
</script>
<style lang="scss">
.active {
  color: #348cff;
}
.speed-wrap {
  position: relative;
  .el-dropdown-menu {
    top: 43px;
    transform-origin: center bottom;
    z-index: 2003;
  }
  .el-dropdown-menu__item {
    word-break: normal;
  }
}
.speed {
  display: inline-block;
  width: 30px;
  text-align: right;
}
.custom-audio {
  display: flex;
  align-items: center;
  margin-left: auto;
  margin-right: auto;
  // width: 550px;
  height: 32px;
  padding: 0 16px;
  line-height: 49px;
  background: #eef0f9;
  border-radius: 2px;
  &.disabled * {
    color: #999 !important;
  }

  i {
    font-size: 20px;
    color: #282e51;
    cursor: pointer;
  }

  .time {
    margin-left: 16px;
    line-height: 1;
    font-size: 12px;
    font-weight: bold;
    color: #333333;
  }
  .audio-progress {
    flex: 1;
    display: inline-block;
    // width: 300px;
    height: 6px;
    background: #fff;
    border-radius: 1px;
    margin-left: 16px;
    position: relative;
  }
  .bar {
    height: 100%;
    background: #263ba4;
    display: inline-block;
    position: absolute;
  }

  .audio-download {
    width: 16px;
    height: 16px;
    margin-left: 20px;
    cursor: pointer;
  }
}
</style>
